/* action types */
export const REQUEST_USER_SSO = 'REQUEST_USER_SSO';
export const REQUEST_USER_SSO_FINISHED = 'REQUEST_USER_SSO_FINISHED';
export default {
  REQUEST_USER_SSO,
  REQUEST_USER_SSO_FINISHED,
};
